export default __webpack_public_path__ + "static/media/i-link@3x.33b9691c.webp";